const faqSelectors = {
  showMoreButtons: '.btn-show',
  faqHidden: 'faq-group--hidden',
  faqGroup: '.faq-group',
  section: '.ingridients-faq',
};
/**
 * function to show additional content on click
 *
 */
const showFaq = () => {
  const btn = document.querySelectorAll(faqSelectors.showMoreButtons);
  btn.forEach((b) => {
    b.addEventListener('click', (e) => {
      const section = e.target.closest(faqSelectors.section);
      section.querySelector(faqSelectors.faqGroup).classList.toggle(faqSelectors.faqHidden);
    });
  });
};

window.addEventListener('DOMContentLoaded', () => {
  const showMoreButtons = document.querySelectorAll(`${faqSelectors.showMoreButtons}`);
  if (showMoreButtons.length) {
    showFaq();
  }
});
